module.exports = __webpack_public_path__ + "static/icons/icon-powder-7ed563b23f398d9e49b0c0807467cc96.svg";